module.exports = __webpack_public_path__ + "static/media/car-insurance-protection.ef5ea4dd.svg";